import { useLocation } from 'react-router-dom';
import {
  getLibrarySearch,
  getVideoLibraryPath,
} from '../common/utils/video-route-utils';

export function useVideoLibraryPath(): string {
  const { pathname, search } = useLocation();

  return getVideoLibraryPath(getLibrarySearch(pathname, search));
}
